module.exports = __webpack_public_path__ + "static/media/eventos-Latam(2).258c2307.png";